import { Box, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '60px 10px',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  heroText: {
    fontSize: '24px',
    paddingBottom: '10px',
    color: '#fff',
    lineHeight: '28px',
    fontWeight: '700',
    fontFamily: 'Playfair Display',
    textTransform: 'uppercase',
    [theme.breakpoints.down('lg')]: {
      fontSize: '18px',
      lineHeight: '22px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '20px',
    },
  },
  heroTitle: {
    fontSize: '70px',
    color: '#fff',
    paddingBottom: '10px',
    lineHeight: '80px',
    fontWeight: '800',
    fontFamily: 'Playfair Display',
    textTransform: 'uppercase',
    [theme.breakpoints.down('lg')]: {
      fontSize: '40px',
      lineHeight: '50px',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '30px',
      lineHeight: '40px',
    },
  },
}));

function ProgramsHero({ title, subtitle, actionElement }) {
  const classes = useStyles();

  return (
    <Box
      style={{
        backgroundImage: 'url(/images/programs/hero-background.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Box className={classes.heroSection}>
        <Typography variant="p" className={classes.heroText}>
          {subtitle}
        </Typography>
        <Typography variant="h1" className={classes.heroTitle}>
          {title}
        </Typography>

        {actionElement && actionElement}
      </Box>
    </Box>
  );
}

export default ProgramsHero;
